<template>
  <div class="hello">
    <!-- <div class="homeheader">
      <div class="yztctext">云智停车</div>
      <div>
        <ul>
          <li>
            <router-link to="/home1">首页</router-link>
          </li>
          <li>
            <router-link to="/cz">车主服务</router-link>
          </li>
          <li>
            <router-link to="/parkservice">车场服务</router-link>
          </li>
          <li>
            <router-link to="/shopservice">商户服务</router-link>
          </li>
          <li>
            <router-link to="/aboutus">关于我们</router-link>
          </li>

        </ul>
      </div>
    </div> -->
    <img
      src="../assets/img/homebg.png"
      style="width:100%"
      alt=""
    >
    <div class='product'>
      <div class="yztcjs">
        <div>
          <div style="font-size:25px;">云智停车APP</div>
          <p>车主可通过平台快捷方便地查找到空余泊位，预约泊位，导航至目标停车场。通过在线查找共享泊位资源，支付租赁费用后，即可按时无感出入停车场享受共享泊位服务。同时，个人还可将拥有产权泊位的闲置时段通过“云智停车”APP进行共享发布，增加个人收入，提高个人车位使用率。另外，车主注册成为会员，绑定车牌充值后，车辆即能无感顺畅出入停车场，享受停车券、商家优惠券等在线服务和充电、洗车等更多的配套服务。
          </p>
        </div>
      </div>
      <div class='sjhyjs'>
        <div>
          <div style="font-size:25px;">云智停车信息平台</div>
          <p>利用物联网、互联网、大数据、人工智能等先进技术建成了以泊位共享为核心的城市级停车云平台——云智停车信息平台，拟将昆明市停车场联成一张网，形成城市停车信息公共服务中心，提供两大管理系统（智能停车场/库管理系统、智能充电管理系统）、四大综合服务（公众停车服务、运营管理服务、政府监管服务、开放服务），结合“云智停车”App或微信公众号、小程序，为车场、车主、政府部门提供停车综合信息服务。</p>
        </div>

      </div>
    </div>
    <div class='audio'>
      <video style="margin:0 auto" src="../assets/img/aa.mp4"  width="1000" height="600" controls="controls">
          Your browser does not support the video tag.
    </video>
    </div>
    <about
      ref='aboutl'
      style='heright:600px'
    ></about>
    <div></div>
    <!-- <articlelist></articlelist> -->

  </div>
</template>

<script>
import articlelist from './articlelist';

import about from './about';
export default {
  components: {
    about,
 
    articlelist,
  },
  name: 'home1',
  data() {
    return {
      fileList: [
        {name: '11.jpg', url: 'file:///C:/Users/DELL/Desktop/111.jpg'},
      ],
      item: [
        {
          text: '车主服务',
          styles: ' bounceInRight',
          style: 'icon iconfont icon-chezhuxinxi',
          detaile: `<p>查找附近车位</p><p>车位共享</p><p>车位预约</p><p>停车场状态、价格查询</p>`,
        },
        {
          text: '停车场服务',
          styles: 'bounceInLeft',
          style: 'icon iconfont icon-tingchechang  ',
          detaile: `<p>云接入</p><p>互联网管理</p><p>规范收费规则</p>`,
        },
        {
          text: '商家服务',
          styles: 'bounceInR找ight',
          style: 'icon iconfont icon-shangjia',
          detaile: `<p>使用电子支付与停车场结算方便快捷</p><p>app发送停车卷</p>`,
        },

        {
          text: '开放服务',
          styles: 'bounceInLeft',
          style: 'icon iconfont icon-pingtaiyingyong',
          detaile: `<p>提供便捷API</p><p>平台之间共享资源实现共赢</p>`,
        },
      ],
      msg: 'Welcome to Your Vue.js App',
    };
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.audio{
  width:100%;
  margin:0 auto;
 
 display: flex;
 justify-content: center;
 justify-items: center
 
}

.yztcjs,
.sjhyjs {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-items: center;
  padding: 50px;
  max-width: 600px;
 
  margin: 0 auto;
}
.product {
   
  background-color: #21d4fd;
  background-image: linear-gradient(30deg, #21d4fd 45%, #215dff 100%);
  display: flex;
  justify-content: space-around;
  height: 60vh;
padding-left: 7.5%;
padding-right: 7.5%;
   
  justify-items: center;  color: #fff;

}
.product > div {
  width: 50%;
}
.product p {
  font-size: 16px;
  line-height: 35px;

  margin-top: 30px;
  overflow: hidden;
}
button {
  display: block;
  padding-top: 20px;
  width: 90px;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  margin-top: 10px;
}
button:hover {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
.down {
  display: flex;
  justify-content: space-around;
  margin-left: -80px;
}
.xuanchaun {
  width: 300px;
  padding-top: 200px;
  padding-left: 200px;
  color: #ffffff;
}
.xuanchaun h4 {
  padding-bottom: 20px;
  letter-spacing: 4px;
}
.xuanchaun p {
  padding-bottom: 20px;
}

.yztc {
  font-size: 2rem;
  text-align: center;
  padding: 30px;
  padding-left: 0px;
  letter-spacing: 5px;
  margin-top: 120px;
}

.integrated {
  font-size: 30px;
  color: #00b0d3;
}
ul {
  text-align: center;
}
ul {
  width: 1100px;
  margin: 0 auto;
}
li {
  display: inline-block;
  width: 200px;
  height: 50px;
  font-size: 1.1rem;
  text-align: center;
  letter-spacing: 4px;
  line-height: 30px;
  line-height: 50px;
  color: #ffffff;
  border-right: 1px solid #FFF;
  overflow: hidden;
}
li a {
  color: #ffffff;
}
.a {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.item {
  border-radius: 50%;
  border: 1px solid #40bfdb;
  width: 130px;
  margin: 0px auto;
  height: 130px;
  background-color: #f5fafb;
}
.item i {
  font-size: 60px !important;
  color: #40bfdb;
  line-height: 130px;
}
.item:hover {
  background-color: #40bfdb;
  /* animation: move 2s linear infinite; */
}
.item:hover i {
  color: #ffffff;
  /* animation: move 2s linear infinite; */
}
.homeheader {
  height: 176px;
  width: 100%;
  background-color: #21b8fd;
  color: #ffffff;
  text-align: center;
}
.yztctext {
  padding: 20px 0px 35px 0px;
  font-size: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/home1.vue